import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import withDynamicUrlValidation from "UIComponents/DynamicUrlValidator";
import { injectReducer } from "store/reducers";
import { NAME as commentTemplateReducerName } from "CommentTemplates/modules/CommentTemplatesModule";
export default store => ({
  path: ":studentProgressReportId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "course-studnetProgressreport" */ "./components"
        ),
        import(
          /* webpackChunkName: "course-studnetProgressreport" */ "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule"
        ),
        import(
          /* webpackChunkName: "course-studnetProgressreport" */ "CommentTemplates/modules/CommentTemplatesModule"
        ),
        import(
          /* webpackChunkName: "course-studnetProgressreport" */ "ProgressReport/modules/ProgressReportModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const component = importedModule0.default;
          const multiLevelNodeEditorReducer = importedModule1;
          const commentTemplatesReducer = importedModule2;
          const progressReportReducer = importedModule3.default;
          injectReducer(store, {
            key: "progressReport",
            reducer: progressReportReducer,
          });
          injectReducer(store, {
            key: "multiLevelNodeEditor",
            reducer: multiLevelNodeEditorReducer.default,
          });
          injectReducer(store, {
            key: commentTemplateReducerName,
            reducer: commentTemplatesReducer.default,
          });
          return withDynamicUrlValidation({
            component,
            urlValidationType: "number",
          });
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [],
});
